import { render, staticRenderFns } from "./WaitSend.vue?vue&type=template&id=05a19742&scoped=true&"
import script from "./WaitSend.vue?vue&type=script&lang=js&"
export * from "./WaitSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a19742",
  null
  
)

export default component.exports